var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilament(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70347 12.5959H43.4476C44.6085 12.5959 45.5496 11.6341 45.5496 10.4478C45.5496 9.26144 44.6085 8.2998 43.4476 8.2998H8.70347C7.54265 8.2998 6.60156 9.26154 6.60156 10.4478C6.60146 11.6341 7.54255 12.5959 8.70347 12.5959Z",
    fill: "#F1805E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70347 19.3332H43.4476C44.6085 19.3332 45.5496 18.3714 45.5496 17.1851C45.5496 15.9988 44.6085 15.0371 43.4476 15.0371H8.70347C7.54265 15.0371 6.60156 15.9988 6.60156 17.1851C6.60156 18.3714 7.54255 19.3332 8.70347 19.3332Z",
    fill: "#F1805E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60156 23.9234C6.60156 25.1098 7.54265 26.0714 8.70347 26.0714H43.4477C44.6086 26.0714 45.5497 25.1097 45.5497 23.9234C45.5497 22.737 44.6086 21.7754 43.4477 21.7754H8.70357C7.54265 21.7753 6.60156 22.737 6.60156 23.9234Z",
    fill: "#F1805E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V3.12319H6.68631C6.63446 3.30986 6.60491 3.5061 6.60491 3.70963C6.60491 4.89602 7.546 5.85766 8.70682 5.85766H43.4511C44.612 5.85766 45.5531 4.89592 45.5531 3.70963C45.5531 3.50599 45.5235 3.30975 45.4717 3.12319H52.158V0L0 0Z",
    fill: "#F1805E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3414 28.5137H8.70692C7.546 28.5137 6.60491 29.4754 6.60491 30.6617C6.60491 30.8594 6.63323 31.0499 6.68213 31.2318H0V34.355H29.6573C29.712 34.5464 29.7428 34.7484 29.7428 34.9579V51.1543C29.7428 52.3407 30.6839 53.3024 31.8448 53.3024C33.0057 53.3024 33.9467 52.3406 33.9467 51.1543V34.2418C33.9467 31.0782 31.4371 28.5137 28.3414 28.5137Z",
    fill: "#F1805E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5461 30.6617C45.5461 29.4753 44.605 28.5137 43.4441 28.5137H34.9297C36.2166 30.0588 36.9957 32.0586 36.9957 34.2418V34.355H52.151V31.2318H45.4689C45.5178 31.05 45.5461 30.8594 45.5461 30.6617Z",
    fill: "#F1805E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilament);
export default __webpack_public_path__ + "static/media/filament.3d1031c73c6edb057618b872d081bcb5.svg";
export { ForwardRef as ReactComponent };